import { render, staticRenderFns } from "./AdminReportForm.vue?vue&type=template&id=38a5038a&scoped=true"
import script from "./AdminReportForm.vue?vue&type=script&lang=js"
export * from "./AdminReportForm.vue?vue&type=script&lang=js"
import style0 from "./AdminReportForm.vue?vue&type=style&index=0&id=38a5038a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5038a",
  null
  
)

export default component.exports